<template>
  <div class="case-detail-gene-acmg-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ 'ACMG'/* ___ */ }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '5px' }"></div>
    <div v-if="acmg" class="data-container col-block">
      <div class="acmg-table-container col-block">
        <div class="acmg-table-block" v-for="(variant, vkey, vindex) in variants" :key="vindex">
          <div class="acmg-table">
            <!--  -->
            <div class="table-row row-block stretch">
              <div class="table-col col-block" :style="{ flex: 1 }">
                <div class="table-cell hgvsc col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div
                    class="table-content ellipsis"
                    :title="variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'"
                    v-html="variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -'"
                  ></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div class="table-col tab col-block" :style="{ flex: 3 }">
                <div class="table-cell consequence col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content" v-html="getACMGConsequence(gene, vkey)"></div>
                  <div :style="{ flex: 1 }"></div>
                </div>
                <div class="tab-container row-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="tab-block row-block" :class="{ display: display[vkey] }" @click="e => display[vkey] = !display[vkey]">
                    <div :style="{ width: '16px' }"></div>
                    <div class="tab-title">{{ 'Rules'/* ___ */ }}</div>
                    <div :style="{ width: '8px' }"></div>
                    <img :src="require('../../assets/images/new-tab-display-icon.svg')" alt="">
                    <div :style="{ width: '8px' }"></div>
                  </div>
                </div>
              </div>
            </div>
            <template v-if="display[vkey]">
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell criteria col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">
                      <button class="reset-button gray-button circle-button" @click="e => resetACMG(gene, vkey)">
                        <span>{{ 'Reset'/* ___ */ }}</span>
                      </button>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Benign Criteria'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell pathogenic col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Pathogenic Criteria'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell strength-of-evidence col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Strength of Evidence'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Strong'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell benign-supporting col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Supporting'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-supporting col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Supporting'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-moderate col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Moderate'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Strong'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell pathogenic-very-strong col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Very Strong'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <!--  -->
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Population Data'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BA1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BA1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BA1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BA1'] ? 'benign-strong' : acmg[(gene.SYMBOL || '')][vkey]['BA1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BA1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BA1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BS1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BS1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BS1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BS1'] ? 'benign-strong' : acmg[(gene.SYMBOL || '')][vkey]['BS1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BS1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BS1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BS2'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BS2'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BS2')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BS2'] ? 'benign-strong' : acmg[(gene.SYMBOL || '')][vkey]['BS2'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BS2'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BS2'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-supporting-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-moderate-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM2'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM2'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM2')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM2'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM2'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PM2'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PM2'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PS4'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PS4'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PS4')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PS4'] ? 'pathogenic-strong' : acmg[(gene.SYMBOL || '')][vkey]['PS4'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PS4'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :reverse="true"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PS4'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-very-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">
                      <span>{{ 'Allelic Evidence &'/* ___ */ }}</span><br>
                      <span>{{ 'Cosegrgation Data'/* ___ */ }}</span>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BS4'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BS4'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BS4')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BS4'] ? 'benign-strong' : acmg[(gene.SYMBOL || '')][vkey]['BS4'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BS4'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BS4'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-supporting-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP2'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP2'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP2')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP2'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP2'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP2'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP2'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP5'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP5'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP5')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP5'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP5'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP5'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP5'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-sub-col-container col-block" :style="{ flex: 3 }">
                  <div class="table-sub-cell-container col-block">
                    <div class="table-sub-col-block low-row row-block">
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                          <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PP1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PP1'] === null }">
                            <div class="acmg-option-block row-block">
                              <div :style="{ flex: 1 }"></div>
                              <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PP1')">
                                <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PP1'] ? 'pathogenic-supporting' : acmg[(gene.SYMBOL || '')][vkey]['PP1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                                <div :style="{ width: '5px' }"></div>
                                <div class="acmg-title">{{ 'PP1'/* ___ */ }}</div>
                              </div>
                              <div :style="{ width: '7px' }"></div>
                              <div class="acmg-info center-block">
                                <borCor
                                  :width="'250px'"
                                  :background="'white'"
                                  :border="'#707070'"
                                  :radius="'0px'"
                                  :blockStyle="{
                                    padding: '6px 8px'
                                  }"
                                >
                                  <div slot="trigger">
                                    <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                                  </div>
                                  <div class="content col-block" slot="content">
                                    <div class="text" v-html="acmgMap['PP1'].informations.join('<br>')"></div>
                                  </div>
                                </borCor>
                              </div>
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                    <div class="table-sub-col-block row-block">
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                          <!--  -->
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col pathogenic-moderate-col col-block" >
                          <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM3'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM3'] === null }">
                            <div class="acmg-option-block row-block">
                              <div :style="{ flex: 1 }"></div>
                              <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM3')">
                                <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM3'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM3'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                                <div :style="{ width: '5px' }"></div>
                                <div class="acmg-title">{{ 'PM3'/* ___ */ }}</div>
                              </div>
                              <div :style="{ width: '7px' }"></div>
                              <div class="acmg-info center-block">
                                <borCor
                                  :width="'250px'"
                                  :background="'white'"
                                  :border="'#707070'"
                                  :radius="'0px'"
                                  :blockStyle="{
                                    padding: '6px 8px'
                                  }"
                                >
                                  <div slot="trigger">
                                    <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                                  </div>
                                  <div class="content col-block" slot="content">
                                    <div class="text" v-html="acmgMap['PM3'].informations.join('<br>')"></div>
                                  </div>
                                </borCor>
                              </div>
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </div>
                          <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM6'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM6'] === null }">
                            <div class="acmg-option-block row-block">
                              <div :style="{ flex: 1 }"></div>
                              <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM6')">
                                <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM6'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM6'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                                <div :style="{ width: '5px' }"></div>
                                <div class="acmg-title">{{ 'PM6'/* ___ */ }}</div>
                              </div>
                              <div :style="{ width: '7px' }"></div>
                              <div class="acmg-info center-block">
                                <borCor
                                  :width="'250px'"
                                  :background="'white'"
                                  :border="'#707070'"
                                  :radius="'0px'"
                                  :blockStyle="{
                                    padding: '6px 8px'
                                  }"
                                >
                                  <div slot="trigger">
                                    <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                                  </div>
                                  <div class="content col-block" slot="content">
                                    <div class="text" v-html="acmgMap['PM6'].informations.join('<br>')"></div>
                                  </div>
                                </borCor>
                              </div>
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                      <div class="table-col col-block" :style="{ flex: 1 }">
                        <div class="table-cell acmg-col pathogenic-strong-col col-block">
                          <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PS2'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PS2'] === null }">
                            <div class="acmg-option-block row-block">
                              <div :style="{ flex: 1 }"></div>
                              <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PS2')">
                                <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PS2'] ? 'pathogenic-strong' : acmg[(gene.SYMBOL || '')][vkey]['PS2'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                                <div :style="{ width: '5px' }"></div>
                                <div class="acmg-title">{{ 'PS2'/* ___ */ }}</div>
                              </div>
                              <div :style="{ width: '7px' }"></div>
                              <div class="acmg-info center-block">
                                <borCor
                                  :width="'250px'"
                                  :reverse="true"
                                  :background="'white'"
                                  :border="'#707070'"
                                  :radius="'0px'"
                                  :blockStyle="{
                                    padding: '6px 8px'
                                  }"
                                >
                                  <div slot="trigger">
                                    <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                                  </div>
                                  <div class="content col-block" slot="content">
                                    <div class="text" v-html="acmgMap['PS2'].informations.join('<br>')"></div>
                                  </div>
                                </borCor>
                              </div>
                              <div :style="{ flex: 1 }"></div>
                            </div>
                          </div>
                          <div :style="{ flex: 1 }"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-very-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">
                      <span>{{ 'Computation &'/* ___ */ }}</span><br>
                      <span>{{ 'Predictive Data'/* ___ */ }}</span>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-supporting-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP1'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP3'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP3'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP3')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP3'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP3'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP3'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP3'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP4'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP4'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP4')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP4'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP4'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP4'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP4'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP7'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP7'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP7')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP7'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP7'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP7'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP7'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PP2'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PP2'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PP2')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PP2'] ? 'pathogenic-supporting' : acmg[(gene.SYMBOL || '')][vkey]['PP2'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PP2'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PP2'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PP3'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PP3'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PP3')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PP3'] ? 'pathogenic-supporting' : acmg[(gene.SYMBOL || '')][vkey]['PP3'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PP3'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PP3'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-moderate-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM1'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PM1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PM1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM4'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM4'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM4')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM4'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM4'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PM4'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PM4'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PM5'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PM5'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PM5')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PM5'] ? 'pathogenic-moderate' : acmg[(gene.SYMBOL || '')][vkey]['PM5'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PM5'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PM5'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PS1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PS1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PS1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PS1'] ? 'pathogenic-strong' : acmg[(gene.SYMBOL || '')][vkey]['PS1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PS1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :reverse="true"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PS1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-very-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PVS1'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PVS1'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PVS1')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PVS1'] ? 'pathogenic-very-strong' : acmg[(gene.SYMBOL || '')][vkey]['PVS1'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PVS1'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :reverse="true"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PVS1'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row low-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Functional Data'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BS3'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BS3'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BS3')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BS3'] ? 'benign-strong' : acmg[(gene.SYMBOL || '')][vkey]['BS3'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BS3'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BS3'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-supporting-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-moderate-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-strong-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PS3'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PS3'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PS3')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PS3'] ? 'pathogenic-strong' : acmg[(gene.SYMBOL || '')][vkey]['PS3'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PS3'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :reverse="true"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PS3'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-very-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <div class="table-row row-block stretch">
                <div class="table-col col-block" :style="{ flex: 2 }">
                  <div class="table-cell acmg-col-title col-block">
                    <div :style="{ flex: 1 }"></div>
                    <div class="table-content">{{ 'Other'/* ___ */ }}</div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col benign-supporting-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['BP6'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['BP6'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'BP6')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['BP6'] ? 'benign-supporting' : acmg[(gene.SYMBOL || '')][vkey]['BP6'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'BP6'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['BP6'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-supporting-col col-block">
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PP4'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PP4'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PP4')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PP4'] ? 'pathogenic-supporting' : acmg[(gene.SYMBOL || '')][vkey]['PP4'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PP4'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PP4'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div class="acmg-option-container" :class="{ active: acmg[(gene.SYMBOL || '')][vkey]['PP5'], disabled: false && acmg[(gene.SYMBOL || '')][vkey]['PP5'] === null }">
                      <div class="acmg-option-block row-block">
                        <div :style="{ flex: 1 }"></div>
                        <div class="acmg-content row-block" @click="e => setACMG(gene, vkey, 'PP5')">
                          <img :src="require('../../assets/images/acmg-checkbox-' + (acmg[(gene.SYMBOL || '')][vkey]['PP5'] ? 'pathogenic-supporting' : acmg[(gene.SYMBOL || '')][vkey]['PP5'] !== 0 ? 'empty' : 'disabled') + '.svg')" alt="">
                          <div :style="{ width: '5px' }"></div>
                          <div class="acmg-title">{{ 'PP5'/* ___ */ }}</div>
                        </div>
                        <div :style="{ width: '7px' }"></div>
                        <div class="acmg-info center-block">
                          <borCor
                            :width="'250px'"
                            :background="'white'"
                            :border="'#707070'"
                            :radius="'0px'"
                            :blockStyle="{
                              padding: '6px 8px'
                            }"
                          >
                            <div slot="trigger">
                              <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                            </div>
                            <div class="content col-block" slot="content">
                              <div class="text" v-html="acmgMap['PP5'].informations.join('<br>')"></div>
                            </div>
                          </borCor>
                        </div>
                        <div :style="{ flex: 1 }"></div>
                      </div>
                    </div>
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-moderate-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
                <div class="table-col col-block" :style="{ flex: 1 }">
                  <div class="table-cell acmg-col pathogenic-very-strong-col col-block">
                    <!--  -->
                    <div :style="{ flex: 1 }"></div>
                  </div>
                </div>
              </div>
              <!--  -->
            </template>
            <div class="table-row row-block stretch">
              <div class="table-col col-block" :style="{ flex: 1 }">
                <div class="table-cell automated-criteria col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content">{{ 'Automated criteria'/* ___ */ }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
              <div v-if="display[vkey]" class="table-col col-block" :style="{ flex: 3 }">
                <div class="table-cell explanation col-block">
                  <div :style="{ flex: 1 }"></div>
                  <div class="table-content">{{ 'Explanation'/* ___ */ }}</div>
                  <div :style="{ flex: 1 }"></div>
                </div>
              </div>
            </div>
            <!--  -->
            <template v-if="acmgResults[vkey].length">
              <template v-if="display[vkey]">
                <div class="table-row wrap-row row-block flex-start stretch" v-for="(acmg, aindex) in acmgResults[vkey]" :key="aindex">
                  <div class="table-col col-block" :style="{ width: '25%', 'min-height': '50px' }">
                    <div class="table-cell selected-col-title row-block" :class="[acmg.class + '-title']">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content">{{ acmg.title + ': ' }}<span class="type">{{ acmg.type }}</span></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                  <div class="table-col col-block" :style="{ width: '75%', 'min-height': '50px' }">
                    <div class="table-cell selected-col col-block">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content" v-html="variant[acmg.title + '_explanation'] || '- -'"></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="table-row wrap-row row-block flex-start flex-wrap stretch" :class="['wrap-4']">
                  <div v-for="(acmg, aindex) in acmgResults[vkey]" class="table-col col-block" :style="{ width: '25%', height: '50px' }" :key="aindex">
                    <div class="table-cell selected-col-title row-block" :class="[acmg.class + '-title']">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content">{{ acmg.title + ': ' }}<span class="type">{{ acmg.type }}</span></div>
                      <div :style="{ width: '8px' }"></div>
                      <borCor
                        v-if="variant[acmg.title + '_explanation']"
                        :width="'400px'"
                        :reverse="aindex % 4 >= 2"
                        :background="'white'"
                        :border="'#707070'"
                        :radius="'0px'"
                        :blockStyle="{
                          padding: '6px 8px'
                        }"
                      >
                        <div slot="trigger">
                          <img :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                        </div>
                        <div class="content col-block" slot="content">
                          <div class="text" v-html="variant[acmg.title + '_explanation']"></div>
                        </div>
                      </borCor>
                      <img v-else :src="require('../../assets/images/acmg-info-icon.svg')" alt="">
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                  <div v-if="acmgResults[vkey].length % 4" class="table-col col-block empty" :style="{ flex: 1, height: '50px' }">
                    <div class="table-cell selected-col-title row-block">
                      <div :style="{ flex: 1 }"></div>
                      <div class="table-content"></div>
                      <div :style="{ flex: 1 }"></div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <!--  -->
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import borCor from '../tool/borCor'
import { acmgMap } from '../../constants/global/data'
import { mapActions } from 'vuex'

export default {
  components: {
    borCor
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      acmg: null,
      display: {}
    }
  },
  computed: {
    acmgResults () {
      return Object.entries(this.acmg[(this.gene.SYMBOL || '')]).reduce((result, [vkey, acmg]) => {
        return {
          ...result,
          [vkey]: Object.entries(acmg).filter(([_, value]) => value).map(([key]) => this.acmgMap[key]).filter(x => x)
        }
      }, {})
    },
    // param
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    type () {
      return this.param.type
    },
    // global
    acmgMap () { return acmgMap }
  },
  created () {
    this.acmg = this.param.acmg
    this.display = {
      ...this.display,
      ...Object.keys(this.variants).reduce((s, vkey) => ({ ...s, [vkey]: false }), {})
    }
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    // parent
    getACMGConsequence (gene, vkey) {
      return this.param.functions['getACMGConsequence'](gene, vkey)
    },
    async setACMG (gene, vkey, tag) {
      this.setLoadingAction(true)
      let result = await this.param.functions['setACMG'](gene, vkey, tag)
      this.acmg[(gene.SYMBOL || '')][vkey] = {
        ...this.acmg[(gene.SYMBOL || '')][vkey],
        [tag]: result
      }
      this.setLoadingAction(false)
    },
    async resetACMG (gene, vkey) {
      this.setLoadingAction(true)
      await this.param.functions['resetACMG'](gene, vkey)
      let variant = gene.variants[vkey]
      let defaultACMG = Object.keys(this.acmgMap).concat(['ACMG_Classification']).reduce((s, key) => ({ ...s, [key]: variant[key] }), {})
      this.acmg[(gene.SYMBOL || '')][vkey] = defaultACMG
      this.setLoadingAction(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneACMG.vue